var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-text"},[(_vm.errors)?_c('div',_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_vm._v(_vm._s(error))])}),0):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }